import { cRelatedProductsPackagingUnit }    from "./packaging-unit/related-products-packaging-unit";
import { cRelatedProductsPrimaryPackaging } from "./primary-packaging/related-products-primary-packaging";
import { cRelatedProductsTemperature }      from "./temperature/related-products-temperature";

export class cRelatedProducts{

  packagingUnit;
  primarypackagingUnit;
  temperature;

  constructor() {
    const script = document.querySelector('.c-related-products script') as HTMLScriptElement;
    if (script === null) return;
    const input  = JSON.parse(script.innerText) as {itemId: string};

    const itemId = input.itemId;

    this.packagingUnit          = new cRelatedProductsPackagingUnit(itemId);
    this.primarypackagingUnit   = new cRelatedProductsPrimaryPackaging(itemId);
    this.temperature            = new cRelatedProductsTemperature(itemId);
  }
}